import t from "./index817.js";
import i from "./index818.js";
function e(r) {
  return r != null && i(r.length) && !t(r);
}
export {
  e as default
};
